import { Moment } from "moment";
import { Selection } from "d3";
import {
    CalendarDrawerContent,
    CalendarDrawerSettings,
    CalendarState,
} from "burde";
import { Page, SvgId, CalendarSizeDimensions } from "svg/constants";
import drawLayout from "./dynamic-layout/draw-layout";
import {
    DayModuleElement,
    LayoutFont,
    SvgCalendarLayout,
    WeekModuleElement,
} from "ui/constants";

const drawSinglePage = (
    container: Selection<any, any, any, any>,
    calendar: CalendarState,
    calendarDrawerSettings: CalendarDrawerSettings,
    pageNumber: number,
    layout: SvgCalendarLayout,
    date: Moment,
    Header_WeekNumberPrefix: string,
    fontData: LayoutFont | null,
    calendarDimensions: CalendarSizeDimensions,
    dayModuleElements: DayModuleElement[] | null,
    weekModuleElements: WeekModuleElement[] | null,
    calendarDrawerContent: CalendarDrawerContent,
) => {
    const leftSvg = container
        .append("svg")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr(
            "viewBox",
            `0 0 ${calendarDimensions.svgWidth} ${calendarDimensions.svgHeight}`,
        )
        .classed("svg-content", true)
        .attr("id", `${SvgId}${pageNumber}`)
        .attr("xmlns", "http://www.w3.org/2000/svg");

    drawLayout(
        leftSvg,
        calendar,
        calendarDrawerSettings,
        Page.Odd,
        date,
        Header_WeekNumberPrefix,
        layout,
        fontData,
        false,
        dayModuleElements,
        weekModuleElements,
        calendarDrawerContent,
    );

    const rightSvg = container
        .append("svg")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr(
            "viewBox",
            `0 0 ${calendarDimensions.svgWidth} ${calendarDimensions.svgHeight}`,
        )
        .classed("svg-content", true)
        .attr("id", `${SvgId}${pageNumber}`)
        .attr("xmlns", "http://www.w3.org/2000/svg");

    drawLayout(
        rightSvg,
        calendar,
        calendarDrawerSettings,
        Page.Even,
        date,
        Header_WeekNumberPrefix,
        layout,
        fontData,
        false,
        dayModuleElements,
        weekModuleElements,
        calendarDrawerContent,
    );
};

export { drawSinglePage };
